<template>
  <div class="my-2 flex w-full items-start justify-between text-sm text-neutral-900">
    <div class="flex flex-col justify-start gap-y-1 pr-5">

      <!-- TICKET NAME + AMOUNTS -->
      <div class="flex gap-x-2 items-start">
        <p class="text-sm md:text-base text-neutral-900">{{ ticket.name }}</p>
        <span v-if="item.attributes.length > 1" class="px-[0.65rem] py-[0.15rem] bg-neutral-200 rounded-xl font-medium text-xs md:mt-[0.15rem]">x{{ item.attributes.length }}</span>
      </div>

      <!-- TICKET DATE + TIME -->
      <div class="flex items-center">
        <p class="pb-0 capitalize text-neutral-500">{{ format(ticket.schedule.start, ticket.schedule.end, true) }}</p>
      </div>

      <!-- IF TICKET HAS SEATS -->
      <div class="flex text-neutral-500 gap-1" v-if="item.ticket.seats">
        <span>{{ $t('common.seats') }}:</span>
        <div class="flex flex-col gap-1">
          <div class="flex" v-for="attribute in item.attributes">
            <div v-if="attribute.attributes?.seats" v-for="seat in attribute.attributes.seats">
              <span>{{ seat.row }}</span><span v-if="seat.column" class="ml-1">{{ seat.column }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- IF TICKET IS PACK -->
      <div v-if="item.ticket.pack" class="flex items-center">
        <p class="pb-0 text-neutral-500">{{ $t('common.includes') }}<span class="mx-1">{{ item.ticket.pack + 1 }}</span><span class="lowercase">{{ $t('common.tickets')}}</span></p>
      </div>

    </div>

    <!-- TICKET TOTAL PRICE(S) -->
    <div v-if="!isGuestList" class="text-neutral-900 text-sm md:text-base">
      <div v-if="item.total === item.total_discount ">
        {{ money(item.total) }}
      </div>
      <div v-else>
        <span class="text-neutral-500 line-through mr-2">{{ money(item.total) }}</span>
        <span class="text-green font-medium">{{ money(item.total_discount) }}</span>
      </div>
    </div>

  </div>
</template>
<script lang="ts" setup>
import dayjs, {Dayjs} from "dayjs"
import {useCheckoutStore} from "~/store/checkout"
import {useMoneyFormatter} from "~/composables/moneyFormatter";
import { useDateFormatter } from "~/composables/dateFormatter";

const props = defineProps({
  item: {
    type: Object as PropType<SummaryItem>,
    required: true
  }
})

const money = useMoneyFormatter()
const checkout = useCheckoutStore()
const { df, formatDateLabel } = useDateFormatter()

const ticket = ref<Ticket>(props.item.ticket)
const isSameDay = ref<boolean>(false)

const isGuestList = computed(() => checkout.isGuestList)

function format(start: string, end: string) {
  const startDayUTC = dayjs.utc(start)
  const endDayUTC = dayjs.utc(end)
  const startDateTZ = dayjs.tz(startDayUTC)
  const endDateTZ = dayjs.tz(endDayUTC)

  if (endDateTZ) {
    isSameDay.value = endDateTZ.diff(startDateTZ, 'hour') <= 22
  }

  if (isSameDay.value || !endDateTZ) return formatDateLabel(startDateTZ);

  if (!isSameDay.value) {
    return `${formatDateLabel(startDateTZ, false)} - ${formatDateLabel(endDateTZ, false)} · ${startDateTZ.format(df.t)}`
  }
}
</script>
